import React, { useState, useEffect } from 'react'
import styles from './ui.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { ACTION, ROUTES, PERMISSIONS, VERSION_APP, BUILD_TIME } from 'consts'
import Permission from 'components/permission'
import { useIsMobile } from 'hooks/useMediaQuery'

//components antd
import { Layout, Menu, Popover, notification, Drawer } from 'antd'

//icons antd
import {
  MenuFoldOutlined,
  MenuOutlined,
  CloseOutlined,
  LogoutOutlined,
  UserOutlined,
  DashboardOutlined,
  ChromeOutlined,
  AppstoreOutlined,
  UsergroupAddOutlined,
  ShoppingCartOutlined,
  DollarOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  PaperClipOutlined,
  ThunderboltOutlined,
  FileExcelOutlined,
  BarChartOutlined,
  RocketOutlined,
  InboxOutlined,
  CustomerServiceOutlined,
  SearchOutlined,
} from '@ant-design/icons'

import { Link, useLocation } from 'react-router-dom'


//apis
import NotificationBell from 'components/notification-bell'

const { Sider, Content } = Layout
export default function UI(props) {
  const location = useLocation()
  const [balance, setBalance] = useState({})
  const [username, setUsername] = useState('')
  const dataUser = useSelector((state) => state.login.dataUser)
  const settingApp = useSelector((state) => state.setting)

  const dispatch = useDispatch()
  const [collapsed, setCollapsed] = useState(false)
  const [mobileDrawerVisible, setMobileDrawerVisible] = useState(false)
  const isMobile = useIsMobile()

  const rootSubmenuKeys = ['order', 'resolution', 'setting', 'feed', 'order-invoice-menu', 'money-flow-menu', 'ads-menu', 'research-menu']
  const [openKeys, setOpenKeys] = useState([])

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1)
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys)
    } else {
      localStorage.setItem('openKey', latestOpenKey)
      setOpenKeys(latestOpenKey ? [latestOpenKey] : [])
    }
  }

  const toggle = () => {
    if (isMobile) {
      setMobileDrawerVisible(!mobileDrawerVisible)
    } else {
      setCollapsed(!collapsed)
    }
  }

  const closeMobileDrawer = () => {
    if (isMobile) {
      setMobileDrawerVisible(false)
    }
  }

  const onClickLogout = () => {
    let tmp = localStorage.DisputeColumns
    localStorage.clear()
    if (tmp) localStorage.setItem('DisputeColumns', tmp)
  }

  const content = (
    <div className={styles['popoper']}>
      <Link to="/profile" className={styles['popoper_parent']}>
        <div>
          <UserOutlined />
        </div>
        <div>Account</div>
      </Link>
      <Link to="/login" onClick={onClickLogout}>
        <div className={styles['popoper_parent_bottom']}>
          <div>
            <LogoutOutlined />
          </div>
          <div>Logout</div>
        </div>
      </Link>
    </div>
  )

  const MENUS = [
    {
      path: ROUTES.DASHBOARD,
      title: 'Dashboard',
      permissions: [PERMISSIONS.view_dashboard],
      icon: <DashboardOutlined />,
    },
    {
      path: 'order',
      title: 'Order',
      permissions: [
        PERMISSIONS.view_order,
        PERMISSIONS.view_tracking_order,
        PERMISSIONS.view_order_archive,
      ],
      icon: <ShoppingCartOutlined />,
      menuItems: [
        {
          path: ROUTES.ORDERS,
          title: 'Orders',
          permissions: [PERMISSIONS.view_order],
        },
        {
          path: ROUTES.ORDERS_TRACKING,
          title: 'Orders Tracking',
          permissions: [PERMISSIONS.view_tracking_order],
        },
        {
          path: ROUTES.ORDER_ARCHIVE,
          title: 'Orders Archive',
          permissions: [PERMISSIONS.view_order_archive],
        },
      ],
    },
    {
      path: ROUTES.PRODUCTS,
      title: 'Add new product',
      permissions: [PERMISSIONS.view_product],
      icon: <AppstoreOutlined />,
    },
    // Inventory Menu (below Products) - with submenu
    {
      path: 'inventory-menu',
      title: 'Inventory',
      permissions: [PERMISSIONS.view_inventory],
      icon: <InboxOutlined />,
      menuItems: [
        {
          path: ROUTES.INVENTORY_LISTING,
          title: 'Listing',
          permissions: [PERMISSIONS.view_inventory],
        },
        {
          path: ROUTES.INVENTORY_LISTING_QUEUE,
          title: 'Listing Queue',
          permissions: [PERMISSIONS.view_inventory],
        },
        {
          path: ROUTES.INVENTORY_AMZ_PRODUCT_TYPES,
          title: 'Product Types',
          permissions: [PERMISSIONS.view_inventory],
        },
        {
          path: ROUTES.INVENTORY_FBA_SHIPMENTS,
          title: 'FBA Shipments',
          permissions: [PERMISSIONS.view_inventory],
        },
        {
          path: ROUTES.INVENTORY_PURCHASE_ORDERS,
          title: 'Purchase Orders',
          permissions: [PERMISSIONS.view_purchase_order],
        },
      ],
    },
    {
      path: ROUTES.SITES,
      title: 'Sites',
      permissions: [PERMISSIONS.view_sites],
      icon: <ChromeOutlined />,
    },
    {
      path: ROUTES.SKU_MAPPING,
      title: 'SKU Mapping',
      permissions: [PERMISSIONS.view_sku_mapping],
      icon: <DollarOutlined />,
    },
    {
      path: ROUTES.ANALYTICS,
      title: 'Analytics',
      permissions: [PERMISSIONS.view_analytics],
      icon: <BarChartOutlined />,
    },
    // Ads Menu
    {
      path: 'ads-menu',
      title: 'Ads',
      permissions: [PERMISSIONS.view_ads, PERMISSIONS.view_keywords, PERMISSIONS.view_automation_rules],
      icon: <RocketOutlined />,
      menuItems: [
        {
          path: ROUTES.AMAZON_BULK_ADS,
          title: 'Amazon Bulk Ads',
          permissions: [PERMISSIONS.view_ads],
        },
        {
          path: ROUTES.AMAZON_ADS,
          title: 'Amazon Ads',
          permissions: [PERMISSIONS.view_ads],
        },
        {
          path: ROUTES.SITE_ANALYTICS,
          title: 'Site Analytics (GA4)',
          permissions: [],
        },
        {
          path: ROUTES.AMAZON_ADS_AUTOMATION_RULES,
          title: 'AMZ Ads Automation Rules',
          permissions: [PERMISSIONS.view_automation_rules],
        },
        {
          path: ROUTES.AMAZON_KEYWORDS,
          title: 'Keyword Library',
          permissions: [PERMISSIONS.view_keywords],
        },
      ],
    },
    // Money Flow & Invoice Management
    {
      path: 'order-invoice-menu',
      title: 'Order Invoice',
      permissions: [PERMISSIONS.view_order_invoice, PERMISSIONS.manage_order_invoice],
      icon: <FileExcelOutlined />,
      menuItems: [
        {
          path: ROUTES.ORDER_INVOICE,
          title: 'Order Invoice',
          permissions: [PERMISSIONS.view_order_invoice],
        },
        {
          path: ROUTES.ORDER_INVOICE_SOURCES,
          title: 'Sources & Settings',
          permissions: [PERMISSIONS.manage_order_invoice],
        },
      ],
    },
    {
      path: 'money-flow-menu',
      title: 'Money Flow',
      permissions: [PERMISSIONS.view_money_flow, PERMISSIONS.view_suppliers_payment, PERMISSIONS.view_monthly_report, PERMISSIONS.view_amazon_disbursements],
      icon: <DollarOutlined />,
      menuItems: [
        {
          path: ROUTES.MONEY_FLOW,
          title: 'Overview',
          permissions: [PERMISSIONS.view_money_flow],
        },
        {
          path: ROUTES.MONEY_FLOW_SUPPLIERS,
          title: 'Suppliers',
          permissions: [PERMISSIONS.view_suppliers_payment],
        },
        {
          path: ROUTES.MONEY_FLOW_PAYMENTS,
          title: 'Payments',
          permissions: [PERMISSIONS.view_suppliers_payment],
        },
        {
          path: ROUTES.MONEY_FLOW_MONTHLY_REPORT,
          title: 'Monthly Report',
          permissions: [PERMISSIONS.view_monthly_report],
        },
        {
          path: ROUTES.AMAZON_DISBURSEMENTS,
          title: 'Amazon Disbursements',
          permissions: [PERMISSIONS.view_amazon_disbursements],
        },
      ],
    },
    // Resolution System Menu
    {
      path: 'resolution',
      title: 'Resolution',
      permissions: [PERMISSIONS.view_account_setting, PERMISSIONS.view_dispute],
      icon: <ThunderboltOutlined />,
      menuItems: [
        {
          path: ROUTES.ACCOUNT_SETTING,
          title: 'Account Settings',
          permissions: [PERMISSIONS.view_account_setting],
        },
        {
          path: ROUTES.DISPUTES,
          title: 'Disputes',
          permissions: [PERMISSIONS.view_dispute],
        },
      ],
    },
    {
      path: ROUTES.TRACKING_LOG,
      title: 'Tracking log',
      permissions: [PERMISSIONS.view_tracking_log],
      icon: <PaperClipOutlined />,
    },
    {
      path: ROUTES.USERS,
      title: 'User management',
      permissions: [PERMISSIONS.view_user_management],
      icon: <UsergroupAddOutlined />,
    },
    // {
    //   path: ROUTES.LOGS,
    //   title: 'Logs App',
    //   permissions: [PERMISSIONS.view_logs_app],
    //   icon: <SlidersOutlined />,
    // },
    {
      path: 'setting',
      title: 'Setting',
      permissions: [PERMISSIONS.view_app_setting],
      icon: <SettingOutlined />,
      menuItems: [
        {
          path: ROUTES.SETTING_CATEGORIES,
          title: 'Categories',
          permissions: [PERMISSIONS.view_category],
        },
        {
          path: ROUTES.SETTING_CARRIES,
          title: 'Carriers',
          permissions: [PERMISSIONS.view_carrier],
        },
        {
          path: ROUTES.SETTING_SELLER_LEVELS,
          title: 'Seller levels',
          permissions: [PERMISSIONS.view_seller_level],
        },
        {
          path: ROUTES.SETTING_NEWS,
          title: 'News',
          permissions: [PERMISSIONS.view_news],
        },
        {
          path: ROUTES.SETTING_CONTENT,
          title: 'Content Setting',
          permissions: [PERMISSIONS.view_content_setting],
        },
        {
          path: ROUTES.PRODUCT_TYPES,
          title: 'Products Type',
          permissions: [PERMISSIONS.view_product_type],
        },
        {
          path: ROUTES.SETTING_APP,
          title: 'Setting app',
          permissions: [PERMISSIONS.view_app_setting],
        },
        {
          path: ROUTES.SETTING_PO,
          title: 'Purchase Orders',
          permissions: [PERMISSIONS.view_purchase_order],
          adminOnly: true,
        },
        {
          path: ROUTES.SETTING_FULFILLMENTS,
          title: 'Fulfillments',
          permissions: [PERMISSIONS.view_fulfillment],
          adminOnly: true,
        },
      ],
    },
    // Helpdesk Module (Phase 06)
    {
      path: 'helpdesk',
      title: 'Support',
      permissions: [PERMISSIONS.view_helpdesk_inbox],
      icon: <CustomerServiceOutlined />,
      menuItems: [
        {
          path: ROUTES.HELPDESK_INBOX,
          title: 'Inbox',
          permissions: [PERMISSIONS.view_helpdesk_inbox],
        },
        {
          path: ROUTES.HELPDESK_SLA_SETTINGS,
          title: 'SLA Settings',
          permissions: [PERMISSIONS.manage_helpdesk_settings],
          adminOnly: true,
        },
        {
          path: ROUTES.HELPDESK_STORE_SETTINGS,
          title: 'Stores',
          permissions: [PERMISSIONS.manage_helpdesk_stores],
          adminOnly: true,
        },
        {
          path: ROUTES.HELPDESK_DNS_GUIDE,
          title: 'DNS Setup Guide',
          permissions: [PERMISSIONS.manage_helpdesk_stores],
          adminOnly: true,
        },
        {
          path: ROUTES.HELPDESK_CANNED_REPLIES,
          title: 'Canned Replies',
          permissions: [PERMISSIONS.view_canned_replies],
        },
        {
          path: ROUTES.HELPDESK_BLOCKED_SENDERS,
          title: 'Blocked Senders',
          permissions: [PERMISSIONS.mark_helpdesk_spam],
          adminOnly: true,
        },
      ],
    },
    // Research / FB Ads Library
    {
      path: 'research-menu',
      title: 'Research',
      permissions: [PERMISSIONS.research_fb_ads_search],
      icon: <SearchOutlined />,
      menuItems: [
        {
          path: ROUTES.RESEARCH_FB_ADS,
          title: 'FB Ads Library',
          permissions: [PERMISSIONS.research_fb_ads_search],
        },
        {
          path: ROUTES.RESEARCH_FB_ADS_SETTINGS,
          title: 'Token Settings',
          permissions: [PERMISSIONS.research_fb_ads_manage_config],
          adminOnly: true,
        },
      ],
    },
    // Marketing / Ads Command Center (phase-02+)
    {
      path: 'marketing-menu',
      title: 'Marketing',
      permissions: [PERMISSIONS.fb_marketing_view],
      icon: <SearchOutlined />,
      menuItems: [
        {
          path: ROUTES.MARKETING,
          title: 'Dashboard',
          permissions: [PERMISSIONS.fb_marketing_view],
        },
        {
          path: ROUTES.MARKETING_SETTINGS,
          title: 'Settings',
          permissions: [PERMISSIONS.fb_marketing_view],
        },
      ],
    },
  ]

  // Check if current user is Admin
  const isAdmin = (() => {
    try {
      const role = localStorage.getItem('role')
      return role && JSON.parse(role) === 'Admin'
    } catch {
      return false
    }
  })()

  const renderMenuItem = (_menu) => (
    <Permission permissions={_menu.permissions} key={_menu.path}>
      {_menu.menuItems ? (
        <Menu.SubMenu
          key={_menu.path}
          icon={_menu.icon}
          title={<span style={{ fontWeight: 500 }}>{_menu.title}</span>}>
          {_menu.menuItems
            .filter((e) => !e.adminOnly || isAdmin)
            .map((e) => (
            <Permission permissions={e.permissions} key={e.path}>
              <Menu.Item
                key={e.path}
                icon={e.icon}
                style={{
                  backgroundColor: location.pathname === e.path && '#1890FF',
                }}
                onClick={closeMobileDrawer}>
                <Link
                  to={e.path}
                  style={{
                    fontWeight: 500,
                    color: location.pathname === e.path && 'white',
                  }}>
                  {e.title}
                </Link>
              </Menu.Item>
            </Permission>
          ))}
        </Menu.SubMenu>
      ) : (
        <Menu.Item icon={_menu.icon} key={_menu.path} onClick={closeMobileDrawer}>
          <Link to={_menu.path} style={{ fontWeight: 500 }}>
            {_menu.title}
          </Link>
        </Menu.Item>
      )}
    </Permission>
  )

  // Render menu content (reusable for both Sider and Drawer)
  const renderMenuContent = () => (
    <>
      <div style={{ display: collapsed && !isMobile ? 'none' : '' }}>
        <div className={styles['logo_left_icon']}>
          {(settingApp.link_logo || Object.keys(settingApp).length > 0) && (
            <img
              className={styles['logo_left']}
              src={settingApp.link_logo || '/logo.png'}
              alt="Logo"
            />
          )}
        </div>
      </div>
      <div className={collapsed && !isMobile ? styles['level_left_active'] : styles['level_left']}>
        Your level
      </div>
      <div className={collapsed && !isMobile ? styles['gold_left_active'] : styles['gold_left']}>
        {dataUser.level && dataUser.level.name}
      </div>
      <Menu
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        className={styles['site-layout-background']}
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}>
        {MENUS.map(renderMenuItem)}
        <Menu.Item onClick={() => { onClickLogout(); closeMobileDrawer(); }} key="9" icon={<LogoutOutlined />}>
          <Link to="/login">Logout</Link>
        </Menu.Item>
        {/* Hover hiện giờ deploy — đủ để support truy ra chính xác bản build khi có sự cố */}
        <Menu.Item key="10" title={BUILD_TIME ? `Deployed ${new Date(BUILD_TIME).toLocaleString()}` : ''}>
          Version: {VERSION_APP}
        </Menu.Item>
      </Menu>
    </>
  )

  useEffect(() => {
    if (localStorage.getItem('openKey'))
      setOpenKeys([localStorage.getItem('openKey')])
  }, [])

  useEffect(() => {
    //Saller và supplier thấy đc mục balance
    //Admin ko thấy đc
    if (
      (localStorage.getItem('role') &&
        JSON.parse(localStorage.getItem('role')) === 'Supplier') ||
      JSON.parse(localStorage.getItem('role')) === 'Seller'
    ) {
      MENUS.push({
        path: ROUTES.BALANCE,
        title: 'Balance',
        permissions: [],
        icon: <DollarOutlined />,
      })
    }

    //Saller và supplier sẽ ko thấy đc mục menu transaction
    //Admin sẽ thấy đc
    if (
      localStorage.getItem('role') &&
      JSON.parse(localStorage.getItem('role')) === 'Admin'
    )
      MENUS.push({
        path: 'balance',
        title: 'Transaction',
        permissions: [],
        icon: <DollarOutlined />,
        menuItems: [
          {
            path: ROUTES.SELLER_TRANSACTION,
            title: 'Seller transaction',
            permissions: [],
          },
          {
            path: ROUTES.SUPPLIER_TRANSACTION,
            title: 'Supplier transaction',
            permissions: [],
          },
        ],
      })
  }, [])

  useEffect(() => {
    var data = JSON.parse(localStorage.getItem('balance'))
    var username = JSON.parse(localStorage.getItem('username'))
    setUsername(username)
    setBalance(data)
  }, [])
  return (
    <Layout className={styles['site-layout-background']}>
      {/* Desktop Sidebar */}
      {!isMobile && (
        <Sider
          className={styles['site-layout-background']}
          trigger={null}
          collapsible
          collapsed={collapsed}>
          {renderMenuContent()}
        </Sider>
      )}

      {/* Mobile Drawer */}
      {isMobile && (
        <Drawer
          placement="left"
          onClose={() => setMobileDrawerVisible(false)}
          open={mobileDrawerVisible}
          closable={true}
          bodyStyle={{ padding: 0, backgroundColor: '#001529' }}
          headerStyle={{ backgroundColor: '#001529', borderBottom: '1px solid #303030' }}
          closeIcon={<CloseOutlined style={{ color: 'white' }} />}
          width={280}
          className={styles['mobile-drawer']}>
          {renderMenuContent()}
        </Drawer>
      )}

      <Layout className={styles['site-layout']}>
        <div className={styles['header_custom']}>
          <div className={styles['header_custom_toggle']}>
            {isMobile ? (
              <MenuOutlined
                style={{ fontSize: '1.5rem', margin: '0 0', color: '#1890ff' }}
                onClick={toggle}
              />
            ) : (
              <MenuFoldOutlined
                style={{ fontSize: '1.25rem', margin: '0 0' }}
                onClick={toggle}
              />
            )}
          </div>
          <div className={styles['header_custom_right']}>
            <div className={styles['header_custom_right_question']}>
              <QuestionCircleOutlined style={{ fontSize: '1rem' }} />
            </div>
            <div className={styles['header_custom_right_question']}>
              <NotificationBell />
            </div>
            <Popover content={content}>
              <div className={styles['header_custom_right_users']}>
                <div>
                  <img
                    className={styles['header_custom_right_users_img']}
                    src="/chick.png"
                    alt=""
                  />
                </div>
                <div className={styles['header_custom_right_users_child']}>
                  <div
                    className={
                      styles['header_custom_right_users_child_username']
                    }
                    style={{
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                    }}>
                    {username}
                  </div>
                  <div
                    className={
                      styles['header_custom_right_users_child_username_money']
                    }>
                    ${balance?.available_amount || 0}
                  </div>
                </div>
              </div>
            </Popover>
          </div>
        </div>
        <Content>{props.children}</Content>
      </Layout>
    </Layout>
  )
}
